
import Vue from 'vue';
import '@/assets/css/helpdesk/helpdesk-theme.css';
import Component from 'vue-class-component';
import {namespace} from 'vuex-class';
import PaginationBar from '@/components/shared/PaginationBar.vue';
import EmailHtmlFrame from '@/components/helpdesk/EmailHtmlFrame.vue';
import {IHelpdeskSentEmail} from '@/store/modules/helpdeskSentModule';

const mod = namespace('helpdeskSentModule');

@Component({name: 'HelpdeskSentEmails', components: {EmailHtmlFrame, PaginationBar}})
export default class HelpdeskSentEmails extends Vue {
  @mod.Getter('emails')      private emails!: IHelpdeskSentEmail[];
  @mod.Getter('currentPage') private currentPage!: number;
  @mod.Getter('lastPage')    private lastPage!: number;
  @mod.Getter('total')       private total!: number;
  @mod.Getter('perPage')     private perPage!: number;

  private searchText     = '';
  private filterTo       = '';
  private filterSentBy   = '';
  private filterCc       = '';
  private searchTimer: any = null;
  private selectedPerPage = 15;
  private previewOpen    = false;
  private previewEmail: IHelpdeskSentEmail | null = null;
  private subscribes: any = {};

  private headers = [
    {text: 'Para',           value: 'to_email',       sortable: false},
    {text: 'CC',             value: 'cc_emails',      sortable: false},
    {text: 'CCO',            value: 'bcc_emails',     sortable: false},
    {text: 'Asunto',         value: 'subject',        sortable: false},
    {text: 'Cuenta Gmail',   value: 'gmail_account',  sortable: false},
    {text: 'Enviado por',    value: 'sent_by',        sortable: false},
    {text: 'En respuesta a', value: 'reply_to_email', sortable: false},
    {text: 'Fecha',          value: 'sent_at',        sortable: false, width: 120},
    {text: '',               value: 'actions',        sortable: false, width: 72, align: 'end'},
  ];

  created() {
    this.subscribes = (this as any).$ons({
      'backend.call.OK.sentLoaded': () => {},
      'backend.call.KO.sentLoaded': () => {},
    });
    this.loadData();
  }

  beforeDestroy() { (this as any).$offs(this.subscribes); }

  loadData() {
    const params: any = {page: this.currentPage, per_page: this.selectedPerPage};
    if (this.searchText)   params.search        = this.searchText;
    if (this.filterTo)     params.filter_to     = this.filterTo;
    if (this.filterSentBy) params.filter_sent_by = this.filterSentBy;
    if (this.filterCc)     params.filter_cc     = this.filterCc;
    this.$store.dispatch('helpdeskSentModule/fetchSent', params);
  }

  private onPageChange(page: number) {
    const params: any = {page, per_page: this.selectedPerPage};
    if (this.searchText)   params.search        = this.searchText;
    if (this.filterTo)     params.filter_to     = this.filterTo;
    if (this.filterSentBy) params.filter_sent_by = this.filterSentBy;
    if (this.filterCc)     params.filter_cc     = this.filterCc;
    this.$store.dispatch('helpdeskSentModule/fetchSent', params);
  }

  private onPerPageChange(value: number) {
    this.selectedPerPage = value;
    this.loadData();
  }

  private onSearchInput() {
    clearTimeout(this.searchTimer);
    this.searchTimer = setTimeout(() => { this.loadData(); }, 400);
  }

  private onSearchClear(field: string) {
    if (field === 'search')   this.searchText   = '';
    if (field === 'to')       this.filterTo     = '';
    if (field === 'sent_by')  this.filterSentBy = '';
    if (field === 'cc')       this.filterCc     = '';
    this.loadData();
  }

  private openPreview(item: IHelpdeskSentEmail) {
    this.previewEmail = item;
    this.previewOpen  = true;
  }

  private formatDate(date: string): string {
    if (!date) return '—';
    const d = new Date(date);
    return d.toLocaleDateString('es-ES', {day: '2-digit', month: '2-digit', year: '2-digit'}) +
      ' ' + d.toLocaleTimeString('es-ES', {hour: '2-digit', minute: '2-digit'});
  }
}
